export default __webpack_public_path__ + "static/media/SDG15.363e71e2.png";